import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import Heading from '@marvelapp/marvel-ui/heading';
import MarvelLink from '@marvelapp/marvel-ui/link';
import MaxWidth from '@marvelapp/marvel-ui/max-width';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import ForgotPasswordForm from 'marketing-website/components/modules/ForgotPasswordForm';
import Page from 'marketing-website/components/modules/Page';
import AccountPagesWrap from 'marketing-website/components/modules/AccountPagesWrap';
import { getUrlWithRedirect } from 'marketing-website/utils/forms';
import { SIGNIN } from 'marketing-website/constants/urls';

export default function ResetPassword({ history }) {
  const messaging = {
    header: (
      <MaxWidth value={300}>
        <Spacing type="margin" size="xs" position="bottom">
          <Spacing type="margin" size="xl" sizeM="0" position="right">
            <Heading tag="h1" size="xxxl" weight="bold">
              Reset your password here
            </Heading>
          </Spacing>
        </Spacing>
      </MaxWidth>
    ),
  };

  const signinLinkWithRedirect = getUrlWithRedirect(SIGNIN);

  return (
    <Page
      title="Reset your password – Marvel"
      meta={[
        { name: 'description', content: '' },
        { name: 'keywords', content: '' },
      ]}
      header={false}
    >
      <AccountPagesWrap history={history}>
        <ForgotPasswordForm messaging={messaging} />
        <Paragraph size="m" color="slate">
          Return to{' '}
          <Link to={signinLinkWithRedirect}>
            <MarvelLink type="blue">sign in</MarvelLink>
          </Link>
        </Paragraph>
      </AccountPagesWrap>
    </Page>
  );
}

ResetPassword.propTypes = {
  history: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/pages/signin/reset-password/index.js